module.exports = __webpack_public_path__ + "static/media/flood_2.47c9928e.png";